/* Pages' scope constants */

// App's layout (back-comp.):
export const DESKTOP_LAYOUT_TYPE = 'desktop'; // Symbol('DESKTOP_LAYOUT_TYPE');
export const MOBILE_LAYOUT_TYPE = 'mobile'; // Symbol('MOBILE_LAYOUT_TYPE');

// App's view-mode (back-comp.):
export const STD_VIEW_MODE = 'std'; // Symbol('STD_VIEW_MODE');
export const FULL_VIEW_MODE = 'full'; // Symbol('FULL_VIEW_MODE');
export const VIEW_MODES = [STD_VIEW_MODE, FULL_VIEW_MODE];

// Models:
export const PROJECTS_MODEL = 'projects';
export const LIGHT_PROJECTGROUPS_MODEL = 'newlightprojectgroups';
// USR-400 D01: Should be deleted when all home views will be migrated to new api
export const OLD_LIGHT_PROJECTGROUPS_MODEL = 'lightprojectgroups';
// ******************************************************************************
export const PROJECTGROUPS_MODEL = 'projectgroups';
export const PAGES_MODEL = 'pages';
export const PROFILES_MODEL = 'profiles';
export const MUTABILITIES_MODEL = 'mutabilities';
export const TRANSACTIONS_MODEL = 'transactions';

// Types (== models, for now):
export enum ITEM_TYPES {
  PROJECT = PROJECTS_MODEL,
  PAGE = PAGES_MODEL,
  PROFILE = PROFILES_MODEL,
  MUTABILITY = MUTABILITIES_MODEL,
  TRANSACTION = TRANSACTIONS_MODEL,
}

// Items sort-by modes:
export const ITEMS_DATE_SORTBY = '-modification_date';
export const ITEMS_NAME_SORTBY = '+name';
export const ITEMS_DEFAULT_SORTBY = ITEMS_DATE_SORTBY;
export const ITEMS_SORTBY_MODES = [ITEMS_DATE_SORTBY, ITEMS_NAME_SORTBY];

// Rich map:
export const RICH_MAP_2D_MODE = Symbol('RICH_MAP_2D_MODE');
export const RICH_MAP_3D_MODE = Symbol('RICH_MAP_3D_MODE');
export const RICH_MAP_MODES = [RICH_MAP_2D_MODE, RICH_MAP_3D_MODE];

// Fields:
export const DATE_FIELD_TYPE = 'date';
export const INTEGER_FIELD_TYPE = 'integer';
export const FLOAT_FIELD_TYPE = 'float';
export const STRING_FIELD_TYPE = 'string';
export const BOOLEAN_FIELD_TYPE = 'boolean';
export const RADIO_FIELD_TYPE = 'radio';
export const CHECKBOX_FIELD_TYPE = 'checkbox';

export enum LAYOUT_TYPES {
  HALF_VIEW = 'half view',
  FULL_SCREEN = 'full screen map',
  HIDDEN = 'hidden map',
  THIRD_VIEW = 'third view',
  THIRD_VIEW_FULL_HEIGHT_CONTENT = 'third view with full height content',
  SMALLEST_VIEW = 'smallest view',
}

export const COL_NAME_DEADS_UF = 'UF mortes';

// Popup text constants
export const POPUP_START_PROJECT = 'DÉMARRER UN PROJET';
